import { get_token } from "@/router";

import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";

export default {

  components: {
    Sidebar,
    Navbar
  },
  inject: ['client_features'],

  mounted() {
    this.get_dashboard();

    if (client_domain.includes('dwypd') || client_domain.includes('soulcity') || client_domain.includes('nsp')) {
        this.dwypd_domain = true;
      }
  },

  data() {
    var data = {
      total_users: 0,
      total_portals: 0,
      total_reports: 0,
      total_memberships: 0,
      total_events:0,
      total_business_profiles: 0,
      dwypd_domain:false
    }

    return data;
  },

  methods: {

    toggleSidebar() {
      this.$refs.sidebar.toggle();
    },

    get_dashboard() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/dashboard/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${get_token()}`,
          'Content-Type': 'application/json'
        },
        success: (reponse) => {

          var response_data = reponse.data;

          this.total_users = response_data.total_users || 0;
          this.total_portals = response_data.total_portals || 0;
          this.total_reports = response_data.total_reports || 0;
          this.total_memberships = response_data.total_memberships || 0;
          this.total_events = response_data.total_events || 0;
          this.total_business_profiles = response_data.total_business_profiles || 0;

        },
        error:(response)=>{
          this.$router.push("/");
          if (response.status === 403) {
            Swal.fire({
              icon: "error",
              title: "Access Denied",
              text: "You are not authorized to access dashboard.",
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            });}
        },
        complete: () => {
          this.isLoading = false;
          $('#loader').hide();
        }
      });

    },

  }

}
